import AbstractColumn from "../../../../models/reports/reports/columns/AbstractColumn.js";
import AbstractHtmlEditorColumnRenderer from "./AbstractHtmlEditorColumnRenderer.js";
import AbstractRow from "../../../../models/reports/reports/rows/AbstractRow.js";
import AbstractValueRow from "../../../../models/reports/reports/rows/AbstractValueRow.js";
import CssClassNameVisitor from "../../../../models/reports/reports/CssClassNameVisitor.js";
import RepeatingRow from "../../../../models/reports/reports/rows/RepeatingRow.js";

/**
 * Visitor that only renders a single column with data (eg not a title
 * column) in a report editor.
 */
export default class HtmlEditorDataColumnRenderer extends AbstractHtmlEditorColumnRenderer {
	constructor() {
		super(...arguments);
		this._cssClassNameRenderer = new CssClassNameVisitor();
	}

	visitAbstractColumn(column) {
		this._column = column;

		return (html) => {
			html.div(
				{
					klass: [
						"report-column",
						"data-column",
						this._titleCssClass(column),
						this._cssClassNameRenderer.visit(this._column),
						this._column.getTemplate().getVisibilitySettingId(),
					],
					reportid: column.getTemplate().getId(),
				},
				html
					.div(
						{
							klass: "column-title selectable",
							"data-test": "column-title",
						},
						this._columnTitleRenderer(column),
					)
					.click(() => {
						this._toggleSelection(this._column);
					}),
				this.visitAll(this._report.getRows()),
			);
		};
	}

	visitAbstractRow(row) {
		return this._rowRenderer(row);
	}

	_columnTitleRenderer(column) {
		return (html) => {
			html.span(
				{},
				this._iconRenderer(column),
				this._dimensionIconRenderer(column),
				this._column.getTitleString(),
				this._visibilityIconRenderer(column),
			);
		};
	}

	_cellRenderer(row) {
		return (html) => {
			if (!row.shouldRenderCells()) {
				return;
			}
			const cell = this._report.getCell({
				row,
				column: this._column,
			});

			html.span(
				{ id: cell.getId() },
				this._report.getFormattedData({
					row,
					column: this._column,
					showDash: true,
				}),
			);
		};
	}

	_rowRenderer(row) {
		return (html) => {
			html.div(
				{
					klass: [
						"data",
						"report-row",
						this._cssClassNameRenderer.visit(row),
						this._selectedCssClass(row),
						this._rowVisibilityCssClass(row),
						this._getDepthCssClass(row),
					],
					reportid: this._getRowId(row),
				},
				this._cellRenderer(row),
			);
		};
	}

	_headerRowRenderer(row) {
		return (html) =>
			html.div(
				{
					klass: [
						"data",
						"report-group-data",
						this._getDepthCssClass(row),
						this._rowVisibilityCssClass(row),
					],
				},
				(html) => {
					if (this._report.getShowSummaryRows()) {
						html.span({ klass: "no-data" });
					} else {
						html.render(this._cellRenderer(row));
					}
				},
			);
	}

	_subRowsRenderer(row, subrows) {
		return (html) => html.div(this.visitAll(subrows));
	}

	_summaryRowRenderer(row) {
		return this._rowRenderer(row, "report-group-data summary");
	}
}

AbstractColumn.prototype.iconRenderer = function () {
	return (html) => {
		if (!this.isBudgetColumn()) {
			return;
		}
		html.i({ klass: "far fa-money-bill-alt" });
	};
};

AbstractRow.prototype.shouldRenderCells = function () {
	return false;
};

AbstractValueRow.prototype.shouldRenderCells = function () {
	return true;
};

RepeatingRow.prototype.shouldRenderCells = function () {
	return false;
};
